import { useState } from 'react'

import { SourceRow, type MyResource } from '@krp/platform-ui'
import {
  aqsiFreshness,
  aqsiFreshnessCheck,
  aqsiSourceLine,
  type AqsiFreshnessCheck,
} from '@krp/resource-aqsi-ui'

import { CONNECTION_FORMS } from '../../composition/connectionForms'

/** Свежесть читается из базы службы, кабинет она не трогает: состояние перечитывается, пока вкладка в фокусе. */
const FRESHNESS_POLL_MS = 30_000

/**
 * Вклад AQSI в полосу «Источники» (RP-SEP5) над «Общим каталогом» (RP-SE13): строка одного кабинета с числом товаров, временем последней
 * проверки и итогом. Список источников собирает общая полоса из «моих ресурсов» (RP-SRC1, Е-4); здесь — только то, что умеет вид AQSI.
 * Кнопка «Проверить актуальность» идёт в службу через общий single-flight: если проверка уже идёт или была только что,
 * запроса в кабинет нет, и полоса говорит об этом словами.
 */
export function AqsiSourceStripRow({ resource: source }: { resource: MyResource }) {
  const args = { resourceId: source.id }
  const freshness = aqsiFreshness.useQuery(args, { pollingInterval: FRESHNESS_POLL_MS, skipPollingIfUnfocused: true })
  const [check, state] = aqsiFreshnessCheck.useMutation()
  const [last, setLast] = useState<AqsiFreshnessCheck | null>(null)
  const [failed, setFailed] = useState(false)

  const run = (full: boolean) => {
    setFailed(false)
    void check({ resourceId: source.id, full })
      .unwrap()
      .then(setLast, () => {
        setLast(null)
        setFailed(true)
      })
  }

  const line = aqsiSourceLine(source, freshness.data ?? null, state.isLoading, last)
  const shown = failed && !state.isLoading ? { ...line, note: 'Не удалось выполнить проверку: попробуйте ещё раз' } : line
  return <SourceRow source={shown} tone={CONNECTION_FORMS.toneOf(source.kind)} onCheck={() => run(false)} onCheckFull={() => run(true)} />
}
